export default "__VITE_ASSET__Dlie3Adq__"